import { Link } from 'react-router-dom';
import { useState } from 'react';
import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function HotRecommend() {
  const [activeTab, setActiveTab] = useState('all');

  const tabs = [
    { key: 'all', label: '全部推荐' },
    { key: 'japanese', label: '日系' },
    { key: 'chinese', label: '国产' },
    { key: 'korean', label: '韩漫' },
  ];

  const filtered = activeTab === 'all'
    ? hotComics
    : hotComics.filter(c => c.categorySlug === activeTab);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选最受欢迎的漫画作品，不容错过的精彩内容
            </p>
          </div>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {filtered.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/japanese"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-300 text-primary-600 hover:bg-primary-50 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多热门作品
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}